import { Box, Button, Container, Typography } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Link } from "react-router-dom";

const styles = {
    error: {
        boxShadow: '0 15px 25px #00000019',
        padding: '45px',
        textAlign: 'center',
        margin: '40px auto',
        borderBottom: 'solid 4px #cc0000',
    },
    errorIcon: {
        fontSize: '55px',
        color: '#cc0000',
    },
    errorHeading: {
        marginBottom: '12px',
        marginTop: '10px',
    },
    errorSubHeading: {
        marginBottom: '0px',
        fontSize: {
            md: '32px',
            xs: '24px',
        },
        color: '#495057',
        fontWeight: 500,
    },
    backIcon: {
        fontSize: '30px',
        color: '#cc0000',
    },
}

const Error404 = () => {
    return (
        <Container maxWidth={'100%'} sx={{ paddingLeft: 0 }} style={{ padding: 0 }}>
            <Box sx={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Box sx={{ alignSelf: 'center' }}>
                    <Box sx={styles.error}>
                        <CancelIcon sx={styles.errorIcon} />
                        <Typography sx={styles.errorSubHeading}> 404 </Typography> 
                        <Typography variant="h4" sx={styles.errorHeading}> The requested page was not found! </Typography> 
                        <Link to="/student"><Button type="button" color="error"><KeyboardReturnIcon sx={styles.backIcon} /> Go To Home</Button></Link> 
                    </Box>
                </Box>
            </Box>
        </Container>
    )
}

export default Error404;